import { TokenV2, createTokenV2, encodeToken } from "@cur8/frango";

export function createSessionToken(sessionId: string, siteId: string) {
  return createTokenV2(sessionId, siteId);
}

export function createPatientDeviceURL(
  token: TokenV2,
  baseURL: string,
  authMethod: AuthMethod
) {
  const obfuscatedToken = encodeToken(token);
  const path = ["concierge", "check-in", obfuscatedToken]
    .map(encodeURIComponent)
    .join("/");
  const url = new URL(baseURL + "/" + path);
  url.search = `?authmethod=${authMethod}`;
  return url.toString();
}

export type AuthMethod = "bankid" | "phoneauth";
